module.exports = __webpack_public_path__ + "static/media/mobile-spin-clabs.ac03d725.png";